<script lang="ts">
  import { initials } from '../format';
  let { name, color, size = 32, square = false }: { name: string | null | undefined; color?: string; size?: number; square?: boolean } = $props();
</script>

<span class="avatar" class:square style:width="{size}px" style:height="{size}px" style:font-size="{Math.round(size * 0.38)}px" style:--c={color || 'var(--brand)'}>
  {initials(name)}
</span>

<style>
  .avatar {
    display: inline-grid; place-items: center; flex-shrink: 0;
    border-radius: var(--radius-full);
    background: color-mix(in srgb, var(--c) 14%, var(--surface));
    color: var(--c);
    font-weight: var(--weight-bold);
    letter-spacing: 0.01em;
    user-select: none;
  }
  .square { border-radius: var(--radius-sm); }
</style>
